module.exports = __webpack_public_path__ + "static/media/599702 (4).1a638b48.pdf";